import { defineStore } from 'pinia';
import { getPassMenus, getPublicMenus, getServiceConfig, getUserFirstMenu } from '../../api/menu';
import {
  externalLoginSend,
  loginGust,
  openmenus,
  orgIdByHostSend,
  srvAutoLogin,
  webLoginSend
} from '../../api/user';
import { TOKEN_NAME } from '../../config/global';
import { useTabsRouterStore } from '../../store/modules/tabs-router';
import { getKeyJson, getKeyStr, removeKey, removeKeys, setKey, setKeyJsonStr, updateKeyJson } from '../../utils/localStorage';
import { isN } from '../../utils/tools';
import { delIndexDB, getIndexDbMenuKeys } from '../indexDb';
import ws from '../../utils/ws';
import { loadComponent } from 'componentRegistry-utils';
import dayjs from "dayjs";
import { markRaw } from 'vue';

// 注意：不要在模块顶层直接调用 useSettingStore()
// 需要等外部通过 setEnginePinia() 注入后再获取

const InitUserInfo = {
  roles: [],
  name: '',
};

//Pinia数据
//defineStore在页面之间传值，A变化了，B能直接感受到。我们的菜单配置就是存在这里的
//localStorage则不同，是本地存储
export const useUserStore = defineStore('user', {
  state: () => ({
    websocketIsConnected: false, //websocket
    token: localStorage.getItem(TOKEN_NAME), // 默认token不走权限(|| 'main_token')
    roles: [],

    mediaSize: 0,
    // 新增
    rememberMe: false, // 记住密码
    unid: '', // unid
    auth: undefined, //
    tenant: {}, // 租户信息
    iam: '',
    serUrl: '', // 域名（带协议）
    loginUrl: '', //登录首页（带协议）
    sid: '', // 租户SID

    openuri: '', // 用户首页
    routerData: markRaw([]), // 路由数据JSON，仅用于从网络接受数据转路由 
    menuVersion: false, //false早期版本菜单，true新菜单

    menuTree: markRaw([]), // 菜单 用来遍历展示页面UI用的--左边菜单
    menuRight: markRaw([]),    // pid = user 的特殊菜单--右边菜单

    aesKey: '', // 加密解密aeskey
    ctxt: '', // 微服务前缀
    firstMenu: {}, // 登录获取的第一个菜单
    erpConfig: {},
    pidToPageMap: {},
    cacheAction: {},//表格缓存事件
    comParmsKs: {}, // 跨越层级组件全局参数对应K{pid_did_k},
    comParmsVs: {}, // 跨越层级组件全局参数对应值{pid_did_v}
    tableColMap: {}, //表格列全局配置，用于导出时根据ID匹配
    comAction: {}, // 表格导出事件
    dic: {},//业务字典，逐步更新，不要一次更新所有字典到内存
    dicMap: {},//用于表格字典映射,是value:label的map,如， '性别':{ '1': '男', '2': '女' }

    rool: markRaw({}), // 权限
    uinfo: markRaw({}), // 用户信息
    luatosLoginCredential: {
      account: '',
      password: ''
    }, // luatos 登录凭据，password 为加密后的密码
  }),
  getters: {
    // roles: (state) => {
    //   return state.userInfo?.roles;
    // },
    getAuth: (state) => {
      return state.auth;
    },
    getUnid: (state) => {
      return state.unid;
    },
  },
  actions: {
    //管理员登陆
    async webLogin(userInfo: Record<string, unknown>) {
      const val = userInfo['guest'] ? await loginGust(userInfo) : await webLoginSend(userInfo);
      this.saveUserInfo(val, userInfo);
    },

    async externalLogin(userInfo: Record<string, unknown>) {
      const val = await externalLoginSend(userInfo);
      this.saveUserInfo(val, userInfo);
    },

    setLuatosLoginCredential(account: string, password: string) {
      this.luatosLoginCredential = {
        account,
        password
      };
    },

    clearLuatosLoginCredential() {
      this.luatosLoginCredential = {
        account: '',
        password: ''
      };
    },

    // 保存用户信息
    saveUserInfo(val: any, userInfo: Record<string, unknown>) {
      // const userAuth = {...userInfo}; //暂时不用，是下面要往数据库里存的时候用的数据
      if (isN(val)) {
        throw null;
      }
      const { code = -1, value = {} } = val;
      if (code === 0) {
        if (Array.isArray(value) === true) {
          console.log('多个租户');
          throw { res: 'f_more', arr: value };
        } else {
          //重新赋值。不能delete，那样会界面出现onchange未填写
          //此时如果用户使用密码可见，会看到一瞬间变成了如下字符。这个是可以的。
          userInfo['password'] = '******************';
          if (!userInfo.rememberMe) {
            // clear();
            removeKey('reme');
            removeKey('lgusr');
          } else {
            setKey('reme', 'true');
            setKey('lgusr', userInfo.account);
          }

          //通用账号鉴权
          if (value['service']) {
            //账号信息存上，用于比较谁在同一浏览器登录
            value.user['account'] = userInfo['account'];
            console.log('++++++++++++账号信息', value.srv)

            // 保存引擎版本，和上方代码有差别
            const timestamp = Number(import.meta.env.VITE_AGENT_VERSION);
            const buildVer = dayjs(timestamp).format('YYYY-MM-DD HH:mm:ss');
            value.service['enginevar'] = buildVer;
            // 更新localStorage中的service数据
            setKeyJsonStr('service', value.service);
            // setKeyJsonStr('uinfo', value.user);
            this.uinfo = value.user;
            setKeyJsonStr('auth', value.auth);
            setKeyJsonStr('tenant', value.tenant);
            setKeyJsonStr('service', value.service);

            this.unid = value.user.unid;
            this.auth = value.auth;
            this.tenant = value.tenant;
            this.uinfo = value.user;

    

          } else {//租户的客户鉴权
            console.log('客户鉴权')
            //value： salt/token/srv
            //project,customer,oid,sid,nick,mobile
            //账号信息存上，用于比较谁在同一浏览器登录
            //登录用的账号
            setKeyJsonStr('srv', value.srv);

            //账号信息存上，用于比较谁在同一浏览器登录
            value.srv['account'] = userInfo['account'];
            console.log('++++++++++++账号信息', value.srv)
            const user = value.srv
            this.uinfo = {
              unid: user.userid,
              mobile: user.mobile,
              email: user.email,
              name: user.nick,
              uid: user.userid,
              profile: user.profile,
              account: user.name,
              company: user.company
            };
            setKeyJsonStr('auth', {
              token: value.token,
              salt: value.salt,
            });
            setKeyJsonStr('tenant', null);

            this.rememberMe = userInfo.rememberMe;
            this.unid = user.unid;
            this.auth = value.auth;
            this.tenant = value.tenant;
            this.uinfo = value.user;
  

          }

          this.rememberMe = userInfo.rememberMe;
        }

      } else {
        throw value;
      }
    },

    async autoLogin(userInfo: Record<string, unknown>) {//论坛的游客自动的登录
      //先检查本地有没有token及salt等，有就直接用，不用跳转
      //todo 后续将用户登录的信息改为会话级别的，不要使用本地存储
      //几个要素需要全判断，否则可能携带不全而出现参数缺少
      if (isN(getKeyJson('auth')) || isN(getKeyStr('ctxt')) ||
        isN(userInfo) || isN(userInfo['orgid'])) {
        const { code = -1, value = {} } = await srvAutoLogin(`${userInfo['orgid']}`, `${userInfo['ctxt']}`);
        if (code === 0) {
          //返回格式不一样auth主要用于将来放到header中
          setKeyJsonStr('auth', {
            salt: value['salt'], token: value['token'], 'tu': 1,
            'sid': value['srv'] ? value['srv']['sid'] : 'not get'
          });
          setKey('ctxt', userInfo['ctxt']);

          // setKeyJsonStr('uinfo', { 'orgid': userInfo['orgid'], 'nick': '游客'/*, 'isLogin':false*/ })
          this.uinfo = {
            orgid: userInfo['orgid'],
            nick: '游客',
            // isLogin: false
          };
        } else {
          throw value;
        }
      }
    },

    //登录完获取用户第一个登录的菜单，里面会有sid等
    //async表示函数里有异步操作 await表示紧跟在后面的表达式需要等待结果。
    //需要注意的是await关键字只在async函数内有效，如果在async函数体之外使用它，会抛出语法错误。
    async getPublicMenus(params: any) {
      const { code = -1, value = {} } = await getPublicMenus(params);
      if (code === 0) {
        this.firstMenu = value;
        try {
          await this.resetMenu(value, undefined, undefined);
          //this.exChangeMenuToRouter();
        } catch (e) {
          console.error('getPublicMenus》菜单解析错误》 catch >>', e);
          const msg = { msg: `菜单内容异常(${e})` }
          throw msg;
        }
      } else {
        //只要异常，清空，让用户重新注册（可解决本地token超期问题）
        removeKey('auth');
        removeKey('uinfo');
        this.uinfo = {};

        removeKey('ctxt');
        removeKey('uid')

        const msg = { msg: `${value}` }
        throw msg;
      }
    },

    // 获取pid为_开头的菜单
    async getPassMenus(params: any) {
      const { code = -1, value = {} } = await getPassMenus(params);
      if (code === 0) {


        // 远程组件包配置
        const componentConfig = {
          ctxt: value['ctxt'],
          // 中间部分的0原本参数应是nav,暂时未确定如何获取,故暂时固定为0
          componentName: `${value['sid']}_${'0'}_${value['ver']}`
        };


        await loadComponent(componentConfig);

        this.firstMenu = value;
        try {
          await this.resetMenu(value, undefined, undefined);
          //this.exChangeMenuToRouter();
        } catch (e) {
          console.error('getPassMenus》菜单解析错误》 catch >>', e);
          const msg = { msg: `菜单内容异常(${e})` }
          throw msg;
        }
      } else {
        //只要异常，清空，让用户重新注册（可解决本地token超期问题）
        removeKey('auth');
        removeKey('uinfo');
        this.uinfo = {};
        removeKey('ctxt');
        removeKey('uid')
        const msg = { msg: `${value}` }
        throw msg;
      }
    },

    // 登录完获取用户第一个登录的菜单，里面会有sid等
    //async表示函数里有异步操作 await表示紧跟在后面的表达式需要等待结果。
    //需要注意的是await关键字只在async函数内有效，如果在async函数体之外使用它，会抛出语法错误。
    async firstMenuFun() {
      let jsLogin = getKeyJson('login');
      // ========== 后期新增：如果 login 对象或 path 为空，设置默认值 ==========
      jsLogin['path'] = '/login';
      //等于方式是从client-info中获取后存储起来的
      const { nav } = getKeyJson('auth');
      let params = {
        //todo 后续修改为只使用tenantlogin
        //如果是weblogin就使用0，否则都使用租户的客户方式，登录后自行判断是否管理员
        'mowner': 0,
        //(小程序及桌面版，目前都设置为H5小程序1，H5PC 2，web 0)
        'nav': nav,
        //【多域名必带，否则进错系统】；单域名如果带了就按照带的进系统。如果不带则服务端自行判断
        'ctxt': jsLogin['ctxt']
      };

      //如果是租户的用户登录，此时已知微服务，需要携带上下文
      //取出数据库中所有的菜单
      //正常可以将unid作为group，只是这里没有实现
      //group_menu表示菜单查询（在客户端分类时如果越细，则到服务端查询的越少--这是基于入参来说的）
      //组号是将project,nav等都作为group，但此时并不知道group，因此，group是以哪端来区分的
      //key不要包含ver：因为会导致本地存在很多版本。放在value中
      // let uidNavPrefix = `${getKeyJson('uinfo')['unid']}_${params['nav']}_`;
      let uidNavPrefix = `${this.uinfo['unid']}_${params['nav']}_`;
      let ctxtVers: any = await getIndexDbMenuKeys('menus', 'group', uidNavPrefix);
      if (params['mowner'] === 1) {//租户的客户及用户，是能获取微服务的，不用取所有的结果
        //只保留一个当前的结果
        let ctxtv: string;
        if (ctxtVers && ctxtVers.length > 0) {
          for (let v of ctxtVers) {
            if (v.startsWith(jsLogin['ctxt'])) {
              ctxtv = v;
              break;
            }
          }
        }

        //无论如何先重新初始化，然后如果找到了就使用，找不到填写一个错误的版本报上去，触发更新
        ctxtVers = [];
        if (ctxtv) {
          ctxtVers.push(ctxtv);
        } else {
          ctxtVers.push(`${jsLogin['ctxt']}_nover`);
        }
      }
      //由ctxt和ver组成要查询的对象；开始时并不带
      if (ctxtVers && ctxtVers.length > 0) {
        params['keys'] = ctxtVers;
      }

      // 携带用户的groupid, 方便后段更新菜单
      let lsService = getKeyJson('service');
      if (lsService && lsService.groupid) {
        params['groupid'] = lsService.groupid;
      }


      //value不能初始化为{}，因为失败或者其它地方登录，返回的是字符串
      const { code = -1, value } = await getUserFirstMenu(params);
      if (code === 0) {

        //远程组件包配置
        const componentConfig = {
          ctxt: value['ctxt'],
          componentName: `${value['sid']}_${params['nav']}_${value['ver']}`
        };
        await loadComponent(componentConfig);

        this.firstMenu = value;
        try {
          //我们需要在从网络获取数据后，还能清理掉本人旧版本数据，因此需要所有版本
          let keys = [];
          for (let v of ctxtVers) {
            keys.push(uidNavPrefix + v);
          }
          await this.resetMenu(value, keys, uidNavPrefix);
          // this.exChangeMenuToRouter();
        } catch (e) {
          console.error('firstMenuFun》菜单解析错误》 catch >>', e);
          const msg = { msg: `${e}` }
          throw msg;
        }
      } else {
        console.log('firstMenuFun》获取菜单信息异常》 catch >>', value, code);
        // if (code !== 101 && code !== 102 && code !== 105) {
        if (code !== 101) {
          console.error('firstMenuFun》获取菜单信息异常》 catch >>', value, code);
          const msg = { code: code, msg: `${value}` }
          throw msg;
          // return msg;
        }
      }
    },

    // 登录完获取erpconfig
    async loadServiceConfig(ctxt: string, orgid?: string) {
      const val = await getServiceConfig(ctxt, orgid);
      if (isN(val)) {
        return;
      }

      const { code = -1, value = {} } = val;
      if (code === 0) {
        this.erpConfig = value;

        //更新背景图片，下次登录将使用新的图片
        updateKeyJson('login', 'bg', value['s_login_background']);
      } else {
        //如果是token超期，此处的value就是object
        let tip = '';
        if (typeof value === 'string') {
          tip = value;
        }
        //更改提示信息
        const einfo = `[${ctxt}/config] ${tip}`;
        console.error(einfo);
        //只有throw才能在外层catch
        throw einfo;
      }
    },

    // 重新组织菜单
    // eslint-disable-next-line consistent-return
    getroutUri(itm) {
      if (itm['subs']) {
        if (itm.subs.length > 0) {
          let ur = itm.subs[0]['uri'];
          return ur
            .split('/')
            .filter((_item: string, index: number) => index <= 3 && index > 0)
            .map((item: string) => `/${item}`)
            .join('');
        }
      }
      return '';
    },

    async resetMenu(menuObj: any, uidNavCtxtVers: string[], uidNavPrefix: string) {
      // try {
      // const str = unzip(ms);
      // console.log('解压后', str);
      // menuObj = decAesEcb(str, this.aesKey);
      // console.log('aes解密后', menuObj);
      // menuObj = JSON.parse(menuObj);
      // this.sysRes.menu = menuObj;
      // } catch (e) {
      //   console.log('解密异常', e);
      // }
      if (isN(menuObj['sid'])) {
        delIndexDB('menus');
        delIndexDB('dicService');
        throw '没有配置业务ID，请联系管理员';
      }

      if (isN(menuObj['ctxt'])) {
        delIndexDB('menus');
        delIndexDB('dicService');
        throw '没有业务标识';
      }

      this.sid = menuObj.sid;
      this.ctxt = menuObj.ctxt;
      //更新回来的上下文可能和请求的上下文并不相同，更新
      //对于多域名应该是相同；单一域名可能不相同
      updateKeyJson('login', 'ctxt', menuObj.ctxt);

      //获取菜单对象：如果没有groupvalue就用数据库的；如果有业务菜单就用服务器的
      let size = 0;
      let key = `${uidNavPrefix}${menuObj.ctxt}_${menuObj.ver}`;
      let groupValue: any;
      if (isN(menuObj.groupvalue)) {//如果没有返回，说明本地对，使用本地的
        throw `您目前没有可访问的功能`;
        //如果没有，说明服务端查到客户端版本菜单是最新的不需要下载
        //此时异步，必须等待
        /*    groupValue = await getIndexDbMenuVal('menus', 'group', key);
          if (isN(groupValue) || isN(groupValue['m'])) {
             //这种是本地数据损坏，直接删库（所有人的都不必保留）
             //删除这个库，让用户从网络重新获取
             delIndexDB('menus');
             delIndexDB('dicService');
             //可能是该菜单异常，清除本地缓存，让用户可以从默认开始
             // updateKeyJson('login', 'ctxt', undefined);
             throw `菜单异常【${this.ctxt}】，请刷新页面`;
           }
           groupValue = groupValue['m'];//取里面的m
           size = groupValue.length; */
      } else {//有返回，使用网络的
        groupValue = menuObj.groupvalue;
        size = groupValue.length;
        if (size === 0) {
          delIndexDB('menus'); delIndexDB('dicService');
          //可能是该菜单异常，清除本地缓存，让用户可以从默认开始
          // updateKeyJson('login', 'ctxt', undefined);
          throw `没有业务菜单【${this.ctxt}】`;
        }

        /* 暂时不要
        //从网络取，使用两个异步方法删除无效的数据，保存有效数据。需要先确保删除后增加
        if (isNEmpty(uidNavCtxtVers)) {
          await rmvIndexDbMenuKeys('menus', 'group', uidNavCtxtVers);
        }
        setIndexDbMenu('menus', 'group', key, { 'm': groupValue });
        */
        updateKeyJson('service', 'ver', menuObj.ver);

      }

      if (menuObj.menuVersion) {
        this.menuVersion = true;
      } else {
        this.menuVersion = false;
      }

      // 用户菜单
      const newRouter = [];

      try {
        for (let i = 0; i < size; i++) {
          // 数组的 key 是数字时会解析异常
          newRouter.push(JSON.parse(groupValue[i]));
        }
      } catch (e) {
        delIndexDB('menus');
        delIndexDB('dicService');
        throw `菜单资源无法解析【${this.ctxt}】`;
      }

      this.routerData = markRaw(newRouter);
    },

    getOrgIdByHost(host: string) {
      return orgIdByHostSend(host)
    },

    async initUserStore() {
      this.rememberMe = localStorage.getItem('p0');
      this.tenant = getKeyJson('tenant');
      this.sid = '';
      this.serUrl = import.meta.env.VITE_BASE_API;
    },
    async removeToken() {
      this.token = '';
    },
    async clearUser() {
      this.menuVersion = false;
      this.serUrl = '';
      this.loginUrl = '';
      this.sid = '';
      this.openuri = '';
      this.menuTree = [];
      this.menuRight = [];
      this.routerData = [];
      this.aesKey = '';
      this.ctxt = '';
      this.firstMenu = {};
      this.erpConfig = {};
    },

    //清理用户的缓存
    async reCache() {
      localStorage.removeItem(TOKEN_NAME);
      this.token = '';
      this.userInfo = InitUserInfo;
      const tabStore = useTabsRouterStore();
      if (!getKeyStr('reme')) {
        removeKeys(['lgusr', 'reme']);
      }

      removeKeys(['tenant', 'auth', 'unid', 'uinfo', 'rool', 'setting',
        'hashCode']);
      this.uinfo = {}; // 清理用户信息
      this.rool = {}; // 清理用户角色
      this.clearLuatosLoginCredential();

      //保存当前路径；清理当前用户的缓存信息
      // removeKey('currentPath');
      tabStore.removeTabRouterList();
      const $favicon: any = document.querySelector('link[rel="icon"]');
      $favicon.href = '/favicon.ico';
      document.title = '管理系统';
    },
    async logout() {
      ws.stop();
      localStorage.removeItem(TOKEN_NAME);
      this.token = '';
      this.userInfo = InitUserInfo;
      const tabStore = useTabsRouterStore();
      if (!getKeyStr('reme')) {
        removeKeys(['lgusr', 'reme']);
      }

      removeKeys(['tenant', 'auth', 'unid', 'uinfo', 'rool',
        'hashCode', 'current', 'mainTable']);
      this.uinfo = {}; // 清理用户信息
      this.rool = {}; // 清理用户角色
      this.clearLuatosLoginCredential();

      tabStore.removeTabRouterList();
      const $favicon: any = document.querySelector('link[rel="icon"]');
      $favicon.href = '/favicon.ico';
      document.title = '管理系统';
    },

    // iot.luatos.com地址下免登录获取菜单
    async openMenus(orgid: string, ctxt: string) {
      const { code = -1, value = {} } = await openmenus(orgid, ctxt);
      if (code === 0) {

        // 远程组件包配置
        const componentConfig = {
          ctxt: value['ctxt'],
          // 中间部分的0原本参数应是nav,暂时未确定如何获取,故暂时固定为0
          componentName: `${value['sid']}_${'0'}_${value['ver']}`
        };
        await loadComponent(componentConfig);

        this.firstMenu = value;
        try {
          await this.resetMenu(value, undefined, undefined);
        } catch (e) {
          console.error('openMenus》菜单解析错误》 catch >>', e);
          const msg = { msg: `菜单内容异常(${e})` }
          throw msg;
        }
      } else {
        const msg = { msg: `${value}` }
        throw msg;
      }
    },

  },

  // 登录时获取开启持久化，到localStorage：作用，F5刷新时能够保留（方便将来从pinia获取数据）
  // auth等不放pinia是因为在pinia中使用频率不高，可以直接从localStorage中获取
  persist: {
    paths: ['uinfo', 'unid', 'luatosLoginCredential'],
  }
}

);

